<script setup lang="ts">

defineOptions({
  name: 'MetricDisplay'
})

defineProps({
  text: {
    type: String,
    required: true
  }
})

</script>

<template>
  <!-- Style 4: Inline with colon separator -->
  <div class="flex items-center gap-2 w-fit">
    <div class="text-metal-400">{{ text }}:</div>
    <div class="text-metal-200 font-medium">
      <slot></slot>
    </div>
  </div>
</template>

<style scoped lang="scss">

</style>